import styled from 'styled-components';
export const FolderListItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &.active {
    background: #ffba00;
    .anticon {
      color: #fff;
    }
  }
  .anticon {
    font-size: 22px;
    color: #ffba00;
  }
`;
export const PathItem = styled.strong`
  padding: 0 20px;
  width: 350px;
  display: inline-block;
`;